<template>
  <div>
    <div style="margin:1%">
      <b-row align-v="end" align-h="start">
        <b-col>
          <md-button @click.stop="createCard" class="md-raised">{{ $t('Add') }}</md-button>
        </b-col>
      </b-row>
      <b-table small striped hover :items="accessCards" :fields="fields">
      <template v-slot:cell(actions)="row">
        <i @click.stop="ClickOnDeleteButton(row)" class="danger fa fa-trash-alt fa-lg"/>
      </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentRow: null,
    userInfo: null
  },
  data () {
    return {
      card: null,
      groupsUser: [],
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'username', label: this.$i18n.t('Login'), sortable: true },
        { key: 'password', label: this.$i18n.t('Password'), sortable: true },
        { key: 'card_number', label: this.$i18n.t('Card number'), sortable: true },
        { key: 'actions', label: 'Actions' }
      ]
    }
  },
  methods: {
    ClickOnDeleteButton (row) {
      this.card = row.item
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Access card"?'), this.deleteAccessCard, row.item)
    },
    deleteAccessCard () {
      let tmp = {
        card_id: this.card.id,
        card_number: this.card.card_number
      }
      let response = this.$store.dispatch('Users/DELETE_ACCESS_CARDS', tmp)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentRow.user_id)
        } else {
          this.$root.$emit('makeToasts')
          this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentRow.user_id)
        }
      })
    },
    async createCard () {
      let tmp = {
        user_id: this.currentRow.user_id
      }
      let response = this.$store.dispatch('Users/CREATE_ACCESS_CARDS', tmp)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentRow.user_id)
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    accessCards () {
      return this.$store.getters['Users/ACCESS_CARDS']
    }
  },
  watch: {
    currentRow: function (val) {
      this.$store.dispatch('Users/GET_ACCESS_CARDS', val.user_id)
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentRow.user_id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/accessCards/main.vue